import { forwardRef } from 'react';
import WxPayRefundOrderBase from './WxPayRefundOrderBase';
import WxPayRefundOrderEdit from './WxPayRefundOrderEdit';

const WxPayRefundOrder = forwardRef<any, any>((props, ref) => (
    <WxPayRefundOrderBase
        ref={ref}                              // ← 把外部 ref 透传给 Base
        apiId="wxPayRefundOrder"
        titleName="微信退款单"
        WxPayRefundOrderEditComponent={WxPayRefundOrderEdit}
        outerProps={props}
    />
));

export default WxPayRefundOrder;